/* global lightbox */
import lightbox from 'lightbox2';
import 'jquery';

import NavBar from './components/navbar/navbar';
import Input from './components/form/input';
import Slick from './components/hero/hero';

// JS Goes here - ES6 supported
document.addEventListener('DOMContentLoaded', function() {
  const components = [];

  // NavBar
  components.push(new NavBar(document.querySelector('.navbar')));

  // Inputs
  [].map.call(document.querySelectorAll('.c-input'), ($i) => {
    components.push(new Input($i));
  });

  lightbox.option({
    'resizeDuration': 300,
    'fadeDuration': 300,
    'imageFadeDuration': 250,
    'albumLabel': 'Imagen %1 de %2'
  });
});



// WEBPACK FOOTER //
// ./js/app.js